// extracted by mini-css-extract-plugin
export default {"teamLabel":"Teams_teamLabel__aDbuF"};